const STATE_ENTRIES = Object.freeze([
  ["AL", "Alabama"], ["AK", "Alaska"], ["AZ", "Arizona"], ["AR", "Arkansas"],
  ["CA", "California"], ["CO", "Colorado"], ["CT", "Connecticut"], ["DE", "Delaware"],
  ["DC", "District of Columbia"], ["FL", "Florida"], ["GA", "Georgia"], ["HI", "Hawaii"],
  ["ID", "Idaho"], ["IL", "Illinois"], ["IN", "Indiana"], ["IA", "Iowa"],
  ["KS", "Kansas"], ["KY", "Kentucky"], ["LA", "Louisiana"], ["ME", "Maine"],
  ["MD", "Maryland"], ["MA", "Massachusetts"], ["MI", "Michigan"], ["MN", "Minnesota"],
  ["MS", "Mississippi"], ["MO", "Missouri"], ["MT", "Montana"], ["NE", "Nebraska"],
  ["NV", "Nevada"], ["NH", "New Hampshire"], ["NJ", "New Jersey"], ["NM", "New Mexico"],
  ["NY", "New York"], ["NC", "North Carolina"], ["ND", "North Dakota"], ["OH", "Ohio"],
  ["OK", "Oklahoma"], ["OR", "Oregon"], ["PA", "Pennsylvania"], ["RI", "Rhode Island"],
  ["SC", "South Carolina"], ["SD", "South Dakota"], ["TN", "Tennessee"], ["TX", "Texas"],
  ["UT", "Utah"], ["VT", "Vermont"], ["VA", "Virginia"], ["WA", "Washington"],
  ["WV", "West Virginia"], ["WI", "Wisconsin"], ["WY", "Wyoming"],
]);

export const US_STATE_CODES = Object.freeze(STATE_ENTRIES.map(([code]) => code));
export const US_STATE_CODE_TO_NAME = Object.freeze(Object.fromEntries(STATE_ENTRIES));
export const US_STATE_NAME_TO_CODE = Object.freeze(
  Object.fromEntries(STATE_ENTRIES.map(([code, name]) => [name.toLowerCase(), code]))
);
export const US_STATE_OPTIONS = Object.freeze(STATE_ENTRIES.map(([value, label]) => ({ value, label })));

const US_STATE_CODE_SET = new Set(US_STATE_CODES);

export function normalizeUsState(value) {
  if (value == null || typeof value === "object") return null;
  const trimmed = String(value).trim();
  if (!trimmed) return null;
  const upper = trimmed.toUpperCase();
  if (US_STATE_CODE_SET.has(upper)) return upper;
  return US_STATE_NAME_TO_CODE[trimmed.toLowerCase()] || null;
}

export function isValidUsStateCode(value) {
  if (value == null || typeof value === "object") return false;
  return US_STATE_CODE_SET.has(String(value).trim().toUpperCase());
}

export function formatStateName(value) {
  const code = normalizeUsState(value);
  return code ? US_STATE_CODE_TO_NAME[code] : String(value || "").trim();
}
